<template>
  <menu-version-list></menu-version-list>
</template>

<script>
import MenuVersionList from './menu-version-list'

export default {
  name: 'MenuVersion',
  components: { MenuVersionList },
}
</script>
